import { Box, Typography } from "@mui/material";
import styles from "./NoUltrasoundComponent.module.scss";
import ultrasoundNoImage from "../../../../assets/icons/ultrasound_no_image.svg";
import { useTranslation } from "react-i18next";

const NoUltrasoundComponent = () => {
  const { t } = useTranslation();
  return (
    <Box className={styles.ultrasoundNoImageContainer}>
      <Box pt={4} pb={1}>
        <img src={ultrasoundNoImage} alt={t("noUltraSoundHeading")} />
      </Box>
      <Typography variant="h4">{t("noUltraSoundHeading")}</Typography>
      <Typography variant="body1" pt={1} pb={4} pl={2} pr={2}>
        {t("ultrasoundHelp")}
      </Typography>
    </Box>
  );
};

export default NoUltrasoundComponent;

